import ExaminationQuestionSearchFilter from './ExaminationQuestionSearchFilter';

export default ExaminationQuestionSearchFilter;
